<template>
  <div>
    <v-container class="mt-1" style="max-width: 1000px;">
      <v-card>
        <v-card-text>
          <v-tabs v-model="tabModel" centered slider-color="primary" background-color="gray">
            <v-tab href="#tab-1"> <h3>{{ $t("labels.UploadDocuments") }}</h3></v-tab>
            <!-- <v-tab href="#tab-2">
              <h3>
               {{ $t("labels.Notes") }}
              </h3></v-tab
            > -->
          </v-tabs>
          <v-tabs-items v-model="tabModel">
            <v-tab-item value="tab-1">
          


          <div v-if="pd">


              <p  v-html="pd.Desc" />

              <p v-html="$t('messages.UploadDesc')" />

              <v-card  class="mb-3" outlined v-for="(d, idx) in pd.Items" v-bind:key="d.DFRequestDocItemID">
                <v-card-text style="color:black;">
                  <v-row dense>
                    <v-col cols="12" sm="8">
                      <div class="headline" style="font-size: 19px !important;">{{ d.strDFDocumentType }}</div>
                      <div v-if="d.DFRequestDocItemStatusDD == 3 || d.DFRequestDocItemStatusDD == 8"></div>
                      <div v-text="d.Desc" />
                      <v-list-item-subtitle v-if="1==2">{{ d.Desc }}</v-list-item-subtitle>
                      <div class="mt-3">
                        <v-row dense v-for="f in d.Uploads" v-bind:key="f.DFRequestDocItemUploadID">
                          <v-col cols="8">
                            <div class="text-truncate" v-text="f.FileName" />
                          </v-col>
                          <v-col cols="3" v-text="f.strUploadDate" />
                          <v-col cols="1">
                            <a
                              v-if="d.DFRequestDocItemStatusDD == 1 || d.DFRequestDocItemStatusDD == 3 || d.DFRequestDocItemStatusDD == 8 || (d.DFRequestDocItemStatusDD == 4 && f.RemoveFlag == true)"
                              link
                              @click="removeUpload(f.DFRequestDocItemUploadID, d.DFRequestDocItemID)"
                              style="color:red;"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </a>
                          </v-col>
                          <v-col cols="12">
                            <v-divider />
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-col class="text-center" cols="12" v-if="d.DFRequestDocItemStatusDD == 3 || d.DFRequestDocItemStatusDD == 8">
                        <v-chip class="ma-2" color="red" text-color="white">
                          <i class="fas fa-exclamation-circle mr-2"></i> {{ $t("labels.NotAccepted") }}
                        </v-chip>
                      </v-col>
                       <v-col class="text-center" cols="12" v-if="d.DFRequestDocItemStatusDD == 4">
                        <v-chip class="ma-2" color="black" text-color="white">
                          <i class="fas fa-check-circle mr-2"></i> {{ $t("labels.RDSubmitStatus") }}
                        </v-chip>
                      </v-col>
                     

                      <div v-if="d.DFRequestDocItemStatusDD == 1 || d.DFRequestDocItemStatusDD == 3 || d.DFRequestDocItemStatusDD == 8 || d.DFRequestDocItemStatusDD == 4 ">
                        <vue-dropzone
                          :id="'u1' + idx"
                          :options="getDZOpt(d.DFRequestDocItemID)"
                          :destroyDropzone="false"
                          :include-styling="true"
                          @vdropzone-success="onDropzoneSuccess"
                          @vdropzone-sending="onDropzoneSending"
                        ></vue-dropzone>
                      </div>
                      <!-- <div v-if="d.DFRequestDocItemStatusDD == 4">
                        <div class="text-center submitStatus">
                          <i class="fas fa-check-circle fa-3x"></i>
                          <div class="mt-2" style="color:black;" v-html="$t('labels.RDSubmitStatus')" />
                        </div>
                      </div> -->
                      <div v-if="d.DFRequestDocItemStatusDD == 2 || d.DFRequestDocItemStatusDD == 5 || d.DFRequestDocItemStatusDD == 6 || d.DFRequestDocItemStatusDD == 7">
                        <div class="text-center satisfiedStatus">
                          <i class="fas fa-check-circle fa-3x"></i>
                          <div v-if="d.DFRequestDocItemStatusDD == 2 || d.DFRequestDocItemStatusDD == 5" class="mt-2" style="color:black;" v-html="$t('labels.RDSatisfiedStatus')" />
                          <div v-if="d.DFRequestDocItemStatusDD == 6" class="mt-2" style="color:black;" v-html="$t('labels.SubmittedToLender')" />
                          <div v-if="d.DFRequestDocItemStatusDD == 7" class="mt-2" style="color:black;" v-html="$t('labels.AcceptedbyLender')" />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <div class="mt-5">  
                <div class="float-right">             
                  <v-btn v-show="showBackButton" @click="goBack()" color="primary" class="mx-auto mb-4 mr-2">
                    <i class="mr-2"></i> {{ $t("labels.Back") }}
                  </v-btn>
                  <v-btn :disabled="disableSubmitFlag" @click="submitDocs" color="primary" class="mx-auto mb-4">
                    <i class="fas fa-upload mr-2"></i> {{ $t("labels.Submit") }}
                  </v-btn>                   
                </div>              
               <br clear="all" />
              </div>
            </div>
            </v-tab-item>
            <!-- <v-tab-item value="tab-2">
              <v-card flat>
                <v-card-text>
                 <p_note :requestDocID="requestDocID" :siteID="siteID" />
                </v-card-text>
              </v-card>
            </v-tab-item> -->
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-container>
    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import domainHelper from "@/services/domainHelper";
export default {
  components: { vueDropzone: vue2Dropzone  },
  data() {
    return {
      tabModel: "tab-1",
      disableSubmitFlag: true,
      pd: null,
      loadFlag: false,
      siteID: this.$route.params.siteid,
      requestDocID: this.$route.params.requestdocid, 
      lan: localStorageSvc.getLan()  
    };
  },
  computed:{
     showBackButton:function(){
       return this.$route.query.mydeals;
     }
  },

  methods: {
    goBack(){
       this.$router.push("/" + this.siteID + " /user/mydeals")
    },
    getDZOpt(DFRequestDocItemID) {
      return {
        url: domainHelper.getAPIHost() + "/WS/RDDZUpload/" + DFRequestDocItemID,
        parallelUploads: 3,
        // dictDefaultMessage: "<i class='fas fa-upload'></i><br />Drag & drop files here or select files to upload",
        dictDefaultMessage: this.setLabel(),
        previewTemplate: '<div><span data-dz-name></span> <i class="fas fa-spinner fa-spin"></i></div>',
        acceptedFiles: "image/*,.pdf,.doc,.docx,.zip,.xlsx,.xls",
        autoQueue: true,
        autoProcessQueue: true,
        thumbnailWidth: 0
      };
    },
    setLabel(){
      if(this.lan == "en"){
        return "<i class='fas fa-upload'></i><br />Drag & drop files here or select files to upload"
      }else if(this.lan == "fr"){
        return "<i class='fas fa-upload'></i><br />glisser et déposez les fichiers ici ou sélectionnez les fichiers à télécharger"
      }
    },
    onDropzoneSending(file, xhr, formData) {
      formData.append("SiteID", this.siteID);
    },
    onDropzoneSuccess(file, res) {
      if (res == "OK") return;

      try {
        let rv = res;
        this.addFileTo(rv.DFRequestDocItemID, rv.DFRequestDocItemUploadID, rv.FileName, rv.strUploadDate);
      } catch (error) {
        console.error(error);
      }

      this.disableSubmitFlag = false;
      $(file.previewElement).remove();
    },
    reloadPage() {
      //window.location='/' + this.siteID + '/doc/' + this.requestDocID + '/upload';
      location.reload(true);
    },
    submitDocs() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        RequestDocID: this.requestDocID
      };
      dataSvc
        .getHttp()
        .post("/api/RDSubmit", postData)
        .then(res => {
          this.loadFlag = false;
          this.$alert(this.$t("labels.System"), this.$t("labels.SuccessUpload"), () => {
            this.reloadPage();
          });
        });
    },
    removeUpload(dFRequestDocItemUploadID, dFRequestDocItemID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmRemoveUpload"),
        () => {
          let postData = {
            SiteID: this.siteID,
            DFRequestDocItemUploadID: dFRequestDocItemUploadID,
            RequestDocID: this.requestDocID
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/RDRemoveUpload", postData)
            .then(res => {
              this.loadFlag = false;
              for (let i = 0; i < this.pd.Items.length; i++) {
                if (this.pd.Items[i].DFRequestDocItemID == dFRequestDocItemID) {
                  let uploads = this.pd.Items[i].Uploads;

                  this.pd.Items[i].Uploads = uploads.filter(function(el) {
                    return el.DFRequestDocItemUploadID != dFRequestDocItemUploadID;
                  });

                  break;
                }
              }
            });
        },
        () => {}
      );
    },
    getServer(id) {
      let url = domainHelper.getAPIHost()+ "/ws/RDUpload/" + id + "/" + this.siteID;
      return url;
    },
    loadPage() {
      this.checkAccessCode(this.loadPageData);
    },
    loadPageData() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        RequestDocID: this.requestDocID,
        langID: this.lan
      };
      dataSvc
        .getHttp()
        .post("/api/RDLoad", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.pd = res.data.Docs;
          } else {
            this.$alert(
              this.$t("labels.Warning"),
              this.$t("labels.NoRequest"),
              ()=>{
                this.$router.push('/' + this.siteID);
              }
            );
            // this.navCheckAccess();
          }
        });
    },
    navCheckAccess() {
      let url = "/" + this.siteID + "/reqdoc/upload/" + this.requestDocID;
      this.$router.push(url);
    },
    checkAccessCode(callBack) {
      let postData = {
        SiteID: this.siteID,
        RequestDocID: this.requestDocID
      };
      dataSvc
        .getHttp()
        .post("/api/RDACCESS", postData)
        .then(res => {
          if (res.data.ReturnStatus.ReturnCode == 200) {
            if(res.data.ExpiredLink == "Expired"){
              this.$alert(
              this.$t("labels.Warning"),
              this.$t("labels.ExpiredLink"),
              ()=>{
                this.$router.push('/' + this.siteID);
              }
            );
            }else{
              if (!res.data.AccessCode) {
              callBack();
            } else {
              if (res.data.AccessCode == localStorageSvc.getAccessCode()) {
                callBack();
              } else {
                this.navCheckAccess();
              }
            }
            }
            
          } else {
             this.navCheckAccess();
          }
        });
    },

    addFileTo(dFRequestDocItemID, dFRequestDocItemUploadID, fileName, uploadDate) {
      for (let i = 0; i < this.pd.Items.length; i++) {
        let doc = this.pd.Items[i];
        if (doc.DFRequestDocItemID == dFRequestDocItemID) {
          doc.Uploads.push({
            FileName: fileName,
            DFRequestDocItemUploadID: dFRequestDocItemUploadID,
            strUploadDate: uploadDate,
            RemoveFlag: true
          });
        }
      }
    }
  },
  created() {
    this.loadPage();
    document.title = "Upload Documents";
  }
};
</script>
<style>
.vue-dropzone {
  border: 1px dashed #c5c3c3;
  border-radius: 6px;
  font-size: 14px !important;
  min-height: 100px !important;
}

.dropzone.dz-started .dz-message {
  display: block !important;
}

.satisfiedStatus {
  color: green;
  background-color: white;
  border: 1px solid #c5c3c3;
  height: 110px;
  border-radius: 5px;
  padding-top: 24px;
  text-align: center;
}
.submitStatus {
  color: gray;
  background-color: white;
  border: 1px solid #c5c3c3;
  height: 110px;
  border-radius: 5px;
  padding-top: 20px;
  text-align: center;
}
</style>
